import { Injectable } from '@angular/core';
import { UserService } from "../services/user.service";
import { Observable } from 'rxjs/Observable';

@Injectable()
export class OfframpService {

  constructor(private userService: UserService) { }

  //Offramp Customer List
  public getOfframpCustomerList(filter): Observable<any> {
    return this.userService.userequest("post", "offramp-customer", filter);
  }

  //Offramp Trades
  public getAllOfframpTrades(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/trades/getAll", data);
  }

  public createOfframpTrade(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/trades/create", data);
  }

  public updateOfframpTrade(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/trades/update", data);
  }

  public bulkCreateOfframpTrades(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/trades/bulk-create", data);
  }

  // Unused endpoint - not called anywhere in the app
  // public deleteOfframpTrade(data: any): Observable<any> {
  //   return this.userService.userequest("post", "offramp/trades/delete", data);
  // }

  //Offramp Client Quotes
  public getAllOfframpClientQuotes(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/quotes/getAll", data);
  }

  public createOfframpClientQuote(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/quotes/create", data);
  }

  public updateOfframpClientQuote(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/quotes/update", data);
  }

  public deleteOfframpClientQuote(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/quotes/delete", data);
  }

  //Offramp Exchange Quotes
  public getAllOfframpExchangeQuotes(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchange-quotes/getAll", data);
  }

  public createOfframpExchangeQuote(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchange-quotes/create", data);
  }

  public updateOfframpExchangeQuote(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchange-quotes/update", data);
  }

  public deleteOfframpExchangeQuote(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchange-quotes/delete", data);
  }

  //Offramp Clients
  public getAllOfframpClients(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/clients/getAll", data);
  }

  public createOfframpClient(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/clients/create", data);
  }

  public updateOfframpClient(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/clients/update", data);
  }

  public deleteOfframpClient(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/clients/delete", data);
  }

  //Offramp Exchanges
  public getAllOfframpExchanges(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchanges/getAll", data);
  }

  public createOfframpExchange(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchanges/create", data);
  }

  public updateOfframpExchange(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchanges/update", data);
  }

  public deleteOfframpExchange(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchanges/delete", data);
  }

  //Offramp Banks
  public getAllOfframpBanks(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/banks/getAll", data);
  }

  public createOfframpBank(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/banks/create", data);
  }

  public updateOfframpBank(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/banks/update", data);
  }

  public deleteOfframpBank(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/banks/delete", data);
  }

  //Offramp Payout Recharges
  public getAllOfframpPayoutRecharges(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/payout-recharges/getAll", data);
  }

  public createOfframpPayoutRecharge(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/payout-recharges/create", data);
  }

  public updateOfframpPayoutRecharge(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/payout-recharges/update", data);
  }

  //Offramp Exchange Withdrawals
  public getAllOfframpExchangeWithdrawals(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchange-withdrawals/getAll", data);
  }

  public createOfframpExchangeWithdrawal(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchange-withdrawals/create", data);
  }

  public updateOfframpExchangeWithdrawal(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchange-withdrawals/update", data);
  }

  //Offramp Exchange Deposits
  public getAllOfframpExchangeDeposits(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchange-deposits/getAll", data);
  }

  public createOfframpExchangeDeposit(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchange-deposits/create", data);
  }

  public updateOfframpExchangeDeposit(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/exchange-deposits/update", data);
  }

  //Offramp Payout Gateways
  // All configured gateways, active or not (code, name, merchants, maintenance, pause, is_active)
  public getPayoutGatewayLookup(): Observable<any> {
    return this.userService.userequest("get", "offramp/payout-gateways/lookup");
  }

  public getAllPayoutGateways(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/payout-gateways/getAll", data);
  }

  public createPayoutGateway(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/payout-gateways/create", data);
  }

  public updatePayoutGateway(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/payout-gateways/update", data);
  }

  public deletePayoutGateway(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/payout-gateways/delete", data);
  }

  //Offramp Daily Summary
  public getAllOfframpDailySummary(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/daily-summary/getAll", data);
  }

  public updateOfframpDailySummary(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/daily-summary/update", data);
  }

  public regenerateOfframpDailySummary(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/daily-summary/regenerate", data);
  }

  //Offramp Daily Log
  public getAllOfframpDailyLog(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/daily-log/getAll", data);
  }

  //Offramp Crypto Received (auto-detected on-chain; manual add covers what detection missed)
  public getAllOfframpCryptoReceived(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/crypto-received/getAll", data);
  }

  public createOfframpCryptoReceived(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/crypto-received/create", data);
  }

  public updateOfframpCryptoReceived(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/crypto-received/update", data);
  }

  //Offramp Admin Config
  public getAllOfframpAdminConfig(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/admin-config/getAll", data);
  }

  public updateOfframpAdminConfig(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/admin-config/update", data);
  }

  //Offramp Capital Allocation
  public getAllOfframpCapitalAllocations(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/capital-allocations/getAll", data);
  }

  public createOfframpCapitalAllocation(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/capital-allocations/create", data);
  }

  public updateOfframpCapitalAllocation(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/capital-allocations/update", data);
  }

  public deleteOfframpCapitalAllocation(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/capital-allocations/delete", data);
  }

  //Offramp Expenses
  public getAllOfframpExpenses(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/expenses/getAll", data);
  }

  public createOfframpExpense(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/expenses/create", data);
  }

  public updateOfframpExpense(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/expenses/update", data);
  }

  public deleteOfframpExpense(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/expenses/delete", data);
  }

  //Offramp Address Mappings
  public getAllOfframpAddressMappings(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/address-mappings/getAll", data);
  }

  public createOfframpAddressMapping(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/address-mappings/create", data);
  }

  public updateOfframpAddressMapping(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/address-mappings/update", data);
  }

  public deleteOfframpAddressMapping(data: any): Observable<any> {
    return this.userService.userequest("post", "offramp/address-mappings/delete", data);
  }

  //Offramp Balances
  // Payout daily metrics: { date: 'YYYY-MM-DD' (IST day), userId?, gateway?: '<Gateway>_<MId>' }
  public getPayoutDailyMetrics(data): Observable<any> {
    return this.userService.userequest("post", "offramp/payout-daily-metrics", data);
  }

  public getOfframpBalances(): Observable<any> {
    return this.userService.userequest("get", "payout/getOfframpBalances");
  }

  public refreshOfframpBalance(data: any): Observable<any> {
    return this.userService.userequest("post", "payout/refreshOfframpBalance", data);
  }

  //Offramp Monitor
  public getOfframpMonitorDailyReport(data: any): Observable<any> {
    return this.userService.userequest("post", "payout/getOfframpMonitorDailyReport", data);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/offramp.service.ts